import React from "react";
import ShopifyGetCartById from "../utils/ShopifyGetCartById";

const useCheckout = (customer) => {
  const [previousCartLineItems, setPreviousCartLineItems] = React.useState([]);
  const [lastIncompleteCheckout, setLastIncompleteCheckout] = React.useState(null);
  const [checkoutLoading, setCheckoutLoading] = React.useState(false);

  React.useEffect(() => {
    setCheckoutLoading(true);
    if (customer?.lastCartId) {
      ShopifyGetCartById(customer.lastCartId)
        .then((checkout) => {
          if (checkout) {
            setPreviousCartLineItems(checkout.lineItems);
            setLastIncompleteCheckout(checkout);
          }
        })
        .finally(() => {
          setCheckoutLoading(false);
        });
    }
  }, [customer]);

  return {
    previousCartLineItems,
    lastIncompleteCheckout,
    setPreviousCartLineItems,
    checkoutLoading,
  };
};

export default useCheckout;
